/**
 * Alle unterstützen Sprachen als Literale‑Array
 * (wird weiter unten zum Union‑Typ `SupportedLanguage`)
 */
export const supportedLanguages = [
    'en', // Englisch (Default)

    // alphabetisch nach ISO‑Code
    'bg', // Bulgarisch
    'cs', // Tschechisch
    'da', // Dänisch
    'de', // Deutsch
    'el', // Griechisch
    'es', // Spanisch
    'et', // Estnisch
    'fi', // Finnisch
    'fr', // Französisch
    'hr', // Kroatisch
    'hu', // Ungarisch
    'is', // Isländisch
    'it', // Italienisch
    'ja', // Japanisch
    'ko', // Koreanisch
    'lt', // Litauisch
    'lv', // Lettisch
    'nl', // Niederländisch
    'nn-NO', // Norwegisch
    'pl', // Polnisch
    'pt', // Portugiesisch
    'ro', // Rumänisch
    'ru', // Russisch
    'sk', // Slowakisch
    'sl', // Slowenisch
    'sv', // Schwedisch
    'uk', // Ukrainisch
    'vi', // Vietnamesisch
    'zh', // Chinesisch
] as const

/**
 * Union‑Typ "en" | "bg" | … | "zh"
 * – überall wiederverwendbar
 */
export type SupportedLanguage = (typeof supportedLanguages)[number]

export const defaultLanguage: SupportedLanguage = 'en'

export const languageLabels: Record<SupportedLanguage, string> = {
    en: 'English',
    bg: 'Български',
    cs: 'Čeština',
    da: 'Dansk',
    de: 'Deutsch',
    el: 'Ελληνικά',
    es: 'Español',
    et: 'Eesti',
    fi: 'Suomi',
    fr: 'Français',
    hr: 'Hrvatski',
    hu: 'Magyar',
    is: 'Íslenska',
    it: 'Italiano',
    ja: '日本語',
    ko: '한국어',
    lt: 'Lietuvių',
    lv: 'Latviešu',
    nl: 'Nederlands',
    'nn-NO': 'Norsk',
    pl: 'Polski',
    pt: 'Português',
    ro: 'Română',
    ru: 'Русский',
    sk: 'Slovenčina',
    sl: 'Slovenščina',
    sv: 'Svenska',
    uk: 'Українська',
    vi: 'Tiếng Việt',
    zh: '中文',
}

/**
 * Mapping ISO-Code → Open Graph Locale (z. B. "de" → "de_DE")
 */
export const ogLocales: Record<SupportedLanguage, string> = {
    en: 'en_US',
    bg: 'bg_BG',
    cs: 'cs_CZ',
    da: 'da_DK',
    de: 'de_DE',
    el: 'el_GR',
    es: 'es_ES',
    et: 'et_EE',
    fi: 'fi_FI',
    fr: 'fr_FR',
    hr: 'hr_HR',
    hu: 'hu_HU',
    is: 'is_IS',
    it: 'it_IT',
    ja: 'ja_JP',
    ko: 'ko_KR',
    lt: 'lt_LT',
    lv: 'lv_LV',
    nl: 'nl_NL',
    'nn-NO': 'nn_NO',
    pl: 'pl_PL',
    pt: 'pt_PT', // ggf. später erweitern für "pt_BR"
    ro: 'ro_RO',
    ru: 'ru_RU',
    sk: 'sk_SK',
    sl: 'sl_SI',
    sv: 'sv_SE',
    uk: 'uk_UA',
    vi: 'vi_VN',
    zh: 'zh_CN', // oder "zh_TW" falls du Traditionell unterstützt
}
